/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1826fcdc"]'><div :class='["tips-demo"]'><cube-icon type="question" @_click="onIconClick" :class='["cube-tip-demo-icon"]'/><cube-tip :ext-class-tip="(direction)" ref="__mpx_ref_tip__" :direction="(direction)" :custom-style="(customStyle)" :showClose="(showClose)" @close='(e)=>__invoke(e, [["onTipClose"]])'><div>this is tips</div></cube-tip><div :class='["tip-demo-close"]'><div>是否显示关闭按钮：{{showClose}}</div><cube-switch :value="showClose" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","showClose", "__mpx_event__", ["value"], undefined]])'></cube-switch></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_1826fcdc"}'>
.tips-demo
  position relative
  width 300px
  margin 70px auto
  text-align center
  line-height 1
.cube-tip-demo-icon
  font-size 30px
.tip-demo-close
  margin-top: 20px
  line-height 30px
  text-align: left
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1826fcdc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1826fcdc"}
  /** script content **/
  require("./tip.mpx.js?isComponent&outputPath=components%2Ftip1826fcdc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tip.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftip1826fcdc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1826fcdc"],
    ctorType: "component",
    outputPath: "components/tip1826fcdc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-tip':getComponent(require("../../../packages/mpx-cube-ui/src/components/tip/index.mpx?isComponent&outputPath=components%2Findexf2c4f8f0%2Findex")),'cube-switch':getComponent(require("../../../packages/mpx-cube-ui/src/components/switch/index.mpx?isComponent&outputPath=components%2Findexd0fccf8a%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>